import Image from 'next/image';

const people = [
  {
    name: 'Busy Entrepreneur',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/busy-entrepreneur-singapore-ai-workshop-v3.webp',
    bio: 'Are you looking to save time, reduce stress, and enhance productivity to be focused on strategic aspects of your business?',
  },
  {
    name: 'Influencer',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/influencer-singapore-ai-workshop-v3.webp',
    bio: 'Are you creating content that resonates and builds a loyal following?',
  },
  {
    name: 'Marketing Agencies',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/marketing-agency-singapore-ai-workshop-v3.webp',
    bio: 'Are you an expert in driving online engagement and sales. Looking for endless creative ideas and tools to get your job done?',
  },

  {
    name: 'Content Executives',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/content-executive-singapore-ai-workshop-v3.webp',
    bio: 'Are you managing content pipelines and ensuring timely delivery? Looking for tools to streamline your workflow and enhance creative output effortlessly?',
  },
  {
    name: 'Freelancers',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/freelancer-singapore-ai-workshop-v3.webp',
    bio: 'Are you juggling multiple clients and striving to deliver exceptional work on time? Save hours, reduce effort, and spark creativity for every project with ease.',
  },
  {
    name: 'Medium-sized Enterprises',
    imageUrl:
      'https://media.easy-peasy.ai/static/workshop/enterprise-leader-singapore-ai-workshop-v3.webp',
    bio: 'Are you scaling your operations and need efficient solutions to empower your teams? Unlock creativity, streamline processes, and stay ahead of the competition with smart tools and ideas.',
  },

  // More people...
];

export default function Example() {
  return (
    <div className='bg-white py-24 dark:bg-slate-800 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl sm:text-center'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            Is this Workshop for me?
          </h2>
          <p className='mt-6 text-lg leading-8 text-gray-600 dark:text-slate-400'>
            Yes, this workshop is for you if you're looking to save time, boost
            productivity, and enhance creativity. You will learn how to create
            viral content in seconds, get your job done for you, and convert
            ideas into money through hands-on learning and advanced 300+ AI
            tools.
          </p>
        </div>
        <ul
          role='list'
          className='mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-20 sm:grid-cols-2 lg:max-w-4xl lg:gap-x-8 xl:max-w-none'
        >
          {people.map((person) => (
            <li key={person.name} className='flex flex-col gap-6 xl:flex-row'>
              <Image
                className='aspect-[4/5] w-full flex-none rounded-2xl object-cover sm:w-52'
                src={person.imageUrl as string}
                width='400'
                height='500'
                alt=''
              />
              <div className='flex-auto'>
                <h3 className='text-lg font-semibold leading-8 tracking-tight text-gray-900 dark:text-slate-200'>
                  {person.name}
                </h3>
                <p className='mt-6 text-base leading-7 text-gray-600 dark:text-slate-400'>
                  {person.bio}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
